<template>
  <div class="contain-to-grid sticky" id="header-sec">
    <div class="container">
      <nav class="top-bar" data-options="sticky_on: large" data-topbar="" id="navigation">
        <ul class="title-area">
          <li class="name logo-brand">
            <h1><a href="index.html"><img alt="福州百步园艺" src="/skin/images/logo.png"></a></h1>
          </li>
          <li class="toggle-topbar menu-icon"><a href="#">Menu</a></li>
          <li class="mmenu-btn noDis"><a href="#mmenu"><i class="fa fa-bars"></i></a></li>
        </ul>
        <section class="top-bar-section">
          <ul class="right">
            <li class='Lev1 active'> <a href="index.html" class="menu1">网站首页</a></li>
            <li class="Lev1  "> <a href="about.html" class="menu1">关于我们</a></li>
            <li class="Lev1  "> <a href="zwzl.html" class="menu1">植物租赁</a></li>
            <li class="Lev1  "> <a href="fwxm.html" class="menu1">服务项目</a></li>
            <li class="Lev1"> <a href="product.html" class="menu1">成功案例</a></li>
            <li class="Lev1"> <a href="article.html?articleCategoryId=5" class="menu1">新闻动态</a></li>
            <li class="Lev1"> <a href="article.html?articleCategoryId=6" class="menu1">养护知识</a></li>
            <li class="Lev1  "> <a href="contact.html" class="menu1">联系我们</a></li>
            <li class="Lev1  "> <a href="https://baibuzb.taobao.com" target="_blank" class="menu1">网络商城</a></li>
          </ul>
        </section>
      </nav>
    </div>
    <nav id="mmenu" class="noDis">
      <div class="mmDiv">
        <div class="MMhead"> <a href="#mm-0" class="closemenu noblock">x</a> <a href="javascript:;" target="_blank"
                                                                                class="noblock"><i class="fa fa-weibo"></i></a> <a href="javascript:;" target="_blank" class="noblock"><i
          class="fa fa-tencent-weibo"></i></a>
          <!--<a href="" target="_blank" class="noblock">English</a>-->
        </div>
        <div class="mm-search">
          <form class="mm-search-form" name="formsearch" action="/plus/search.php">
            <input type="hidden" name="kwtype" value="0">
            <input type="text" autocomplete="off" value="" name="q" class="side-mm-keyword" placeholder="输入关键字...">
          </form>
        </div>
        <ul>
          <li class="m-Lev1"><a href="../../index.html">网站首页</a></li>
          <li class="m-Lev1"> <a href="..about.html" class="m-menu1">关于我们</a>
            <li class="m-Lev1"> <a href="../xiangmu/index.html" class="m-menu1">服务项目</a>
              <ul class="m-submenu">

                <li class='Lev2'><a href="../xm1/index.html" class='m-menu2'>项目策划</a></li>

                <li class='Lev2'><a href="../xm2/index.html" class='m-menu2'>品牌策划</a></li>

                <li class='Lev2'><a href="../xm3/index.html" class='m-menu2'>品牌推广</a></li>

              </ul>
              <li class="m-Lev1"> <a href="../case/index.html" class="m-menu1">成功案例</a>
                <li class="m-Lev1"> <a href="" class="m-menu1">新闻动态</a>
                  <ul class="m-submenu">

                    <li class='Lev2'><a href="gongsixinwen/index.html" class='m-menu2'>公司新闻</a></li>

                    <li class='Lev2'><a href="hangyedongtai/index.html" class='m-menu2'>行业动态</a></li>

                    <li class='Lev2'><a href="changjianwenti/index.html" class='m-menu2'>常见问题</a></li>

                  </ul>
                  <li class="m-Lev1"> <a href="../lianxiwomen/index.html" class="m-menu1">联系我们</a>
                  </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'HeaderMenu',
  data () {
    return {

    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style scoped>
.menu1{
  font-size: 1.5rem;
  font-weight: bolder;
}
</style>
